import EventTypeForm from "./EventTypeForm";

export default EventTypeForm